<template>
  <div v-if="lifetimeRewardTradeStatus==1">
    <van-nav-bar
      title="一次持仓 终生受益  "
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
      right-text="账单"
      @click-right="$router.push('/member/lifetime_reward_details')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="common_bg">
      <div class="capital-btn">
        <van-row>
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12" class="reward-container">
            <h3 style="margin-top: 30px;">本月奖励</h3>
            <p style="color: #D02E27;">{{ user_lifetime_reward_balance }}</p>
          </van-col>
          <van-col span="6">&nbsp;</van-col>
        </van-row>
      </div>
      <div class="capital-btn" v-if="user_lifetime_reward_balance>0">
        <van-row style="margin-top: 2px;" >
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12" class="reward-container">
            <h4 style="font-size: 15px;font-weight: 100;">领取倒计时</h4>
            <p style="align-items:50px;font-size: 13px; color: #D02E27;">{{days}}天{{hours}}小时{{minutes}}分{{seconds}}秒</p>
          </van-col>
          <van-col span="6">&nbsp;</van-col>
        </van-row>
      </div>
      <div class="capital-btn" style="margin-top: 1px;" v-if="user_lifetime_reward_balance>0">
        <van-row  >
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12">
            <van-button
              type="info"
              size="normal"
              @click="lifetimeRewardTransferState = true; lifetimeRewardAmount = user_lifetime_reward_balance;"
              style="height: 30px; width: 100px; background-color: #0d268d; border:#0d268d; border-radius: 8px;"
              >点击领取
              </van-button
            >
          </van-col>
          <van-col span="6">&nbsp;</van-col>

        </van-row>
      </div>
    </div>
      <div class="common-bg-containerBox">
  <div class="common_bgBox">
    <div class="capital-btn">
        <van-row>
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12" class="reward-container">
            <h4 style="font-size: 13px;font-weight: 100;margin-top: 25px;">累计领取</h4>
            <p style="align-items:50px;font-size: 13px; color: #D02E27;">{{ user_cumulative_collection }}</p>
          </van-col>
          <van-col span="6">&nbsp;</van-col>
        </van-row>
      </div>
  </div>
  <div class="common_bgBox">
    <div class="capital-btn">
        <van-row>
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12" class="reward-container">
            <h4 style="font-size: 13px;font-weight: 100;margin-top: 25px;">累计过期            </h4>
            <p style="align-items:50px;font-size: 13px; color: #D02E27;">{{ user_cumulative_expire_amount }}</p>
          </van-col>
          <van-col span="6">&nbsp;</van-col>
        </van-row>
      </div>
  </div>
  <div class="common_bgBox">
    <div class="capital-btn">
        <van-row>
          <van-col span="6">&nbsp;</van-col>
          <van-col span="12" class="reward-container">
            <h4 style="font-size: 13px;font-weight: 100;margin-top: 25px;">累计奖励            </h4>
            <p style="align-items:50px;font-size: 13px; color: #D02E27;">{{ user_cumulative_lifetime_reward }}</p>
          </van-col>
          <van-col span="6">&nbsp;</van-col>
        </van-row>
      </div>
  </div>
</div>

      <p v-html="lifetimeRewardDesc" style="padding-right: 10px; padding-left: 10px; padding-bottom: 20px; text-align: justify;"></p>
    </van-pull-refresh>

    <!-- ==================== lifetime reward transfer popup ========================== -->

    <van-dialog
      v-model="lifetimeRewardTransferState"
      title="本月奖励"
      show-cancel-button
      :beforeClose="lifetimeRewardTransfer"
    >
      <van-row>
        <van-col span="10">
          <p style="padding-left: 15px; font-size: 15px">可领取奖励:</p>
        </van-col>
        <van-col span="10"
          ><p style="padding-left: 25px; font-size: 15px">
            {{ user_lifetime_reward_balance }}元
          </p></van-col
        >
      </van-row>
    </van-dialog>
  </div>
</template>

<script>
import { min } from 'moment-timezone';

export default {
  name: "LifetimeReward",
  data() {
    return {
      isLoading: false,
      user_lifetime_reward_balance: 0.00,
      user_cumulative_expire_amount: 0.00,
      user_cumulative_lifetime_reward: 0.00,
      user_cumulative_collection: 0.00,
      lifetimeRewardAmount: 0,
      lifetimeRewardTransferState: false,
      lifetimeRewardDesc:'',
      lifetimeRewardTradeStatus: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },
  computed: {},
  methods: {
    getEndOfMonthTime() {
      let that = this;
      const now = new Date();
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const diffInSeconds = Math.floor((endOfMonth - now) / 1000);
      that.days = Math.floor(diffInSeconds / (24 * 3600));
      that.hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
      that.minutes = Math.floor((diffInSeconds % 3600) / 60);
      that.seconds = diffInSeconds % 60;
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    mainMethod() {
      this.getUserinfo();
    },
    onRefresh() {
      this.mainMethod();
      this.isLoading = false;
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.user_lifetime_reward_balance = Number(res.data.data.lifetime_reward_balance).toFixed(2);
            that.user_cumulative_expire_amount = Number(res.data.data.cumulative_lifetime_expire_amount).toFixed(2);
            that.user_cumulative_collection = Number(res.data.data.cumulative_lifetime_reward_amount).toFixed(2);
            that.user_cumulative_lifetime_reward = Number(Number(res.data.data.cumulative_lifetime_expire_amount) + Number(res.data.data.cumulative_lifetime_reward_amount)).toFixed(2);
            that.lifetimeRewardDesc = res.data.data.lifetime_reward_description;
            that.lifetimeRewardTradeStatus = res.data.data.lifetime_reward;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    validateInput (value) {
      // Allow only numbers with up to 2 decimal places
      if (value.startsWith('.')) value = '0' + value; 
      this.lifetimeRewardAmount = value.replace(/[^0-9.]/g, '')           
                .replace(/(\..*?)\..*/g, '$1')     
                .replace(/^(\d+\.?\d{0,2}).*/, '$1');
      
    },
    lifetimeRewardTransfer(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.lifetimeRewardAmount;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "lifetime_reward",
                token: sessionStorage.getItem("token"),
                action: "lifetime_reward_withdraw",
                amount: money,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$toast({
                  message: res.data.msg,
                  type: "success",
                  onClose: function () {
                    that.mainMethod();
                    that.lifetimeRewardAmount = 0;
                    done();
                  },
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
                done(false);
              }
            });
          break;
        case "cancel":
          done();
          break;
      }
    },
  },
  mounted() {
    this.getEndOfMonthTime(); // Initial call
    this.timerInterval = setInterval(() => {this.getEndOfMonthTime(), 1000}); // Update every second
    this.getUserinfo();
  },
};
</script>

<style scoped>
.reward-container h3 {
margin-bottom: 4px; 
}

.reward-container h4 {
margin-bottom: 4px; 
}

.reward-container p {
margin-top: 0; 
}
.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
}

.capital p {
  margin: 0;
  color: #D02E27;
  font-size: 14px;
}

.capital-btn {
  text-align: center;
  padding-bottom: 0px !important;
    margin-bottom: 0px !important;
}

.capital-btn h4 {
  text-align: center;
    margin-top: 5px;
}
.common_bg{
   border:1px solid #e3e3e3!important; 
   border-radius: 20px !important; 
  /* margin:3px 3px !important; */
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom:30px !important;
}

.common-bg-containerBox {
display: flex;
padding: 10px 10px;
justify-content: space-between; /* Adjusts spacing between items */
gap: 10px; /* Adds spacing between divs */
margin-top: 10px;
}

.common_bgBox {
flex: 1; /* Makes each box take equal space */
max-width: 32%; /* Ensures three items fit in one row */
border: 1px solid #e3e3e3 !important;
border-radius: 20px !important;
margin: -10px 0 !important; /* Adjust vertical margin */
padding-bottom: 15px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/LifetimeReward.vue